import {
  IconDefinition,
  IconName,
} from '@fortawesome/fontawesome-common-types';
import { IconPathData } from '@fortawesome/fontawesome-svg-core';

export type IconStyles = 'solid' | 'regular' | 'light' | 'thin' | 'brands';
export type IconFamily = 'classic' | 'duotone' | 'sharp' | 'sharp-duotone';

type IconData =
  | IconPathData
  | {
      width: number;
      height: number;
      path: IconPathData;
    };

export default function styledIcon(
  family: IconFamily = 'classic',
  style: IconStyles = 'thin',
  iconName: IconName,
  width$: number,
  height$: number,
  unicode: string,
  styles: [IconFamily, IconStyles, IconData][]
): IconDefinition {
  const prefix =
    family === 'duotone'
      ? 'fad'
      : style === 'light'
      ? 'fal'
      : style === 'regular'
      ? 'far'
      : style === 'solid'
      ? 'fas'
      : 'fat';

  // const familyPrefix =
  //   family === 'duotone'
  //     ? 'fa-duotone'
  //     : family === 'sharp'
  //       ? 'fa-sharp'
  //       : family === 'sharp-duotone'
  //         ? 'fa-sharp-duotone'
  //         : '';

  // const stylePrefix =
  //   style === 'solid'
  //     ? 'fa-solid'
  //     : style === 'light'
  //       ? 'fa-light'
  //       : style === 'regular'
  //         ? 'fa-regular'
  //         : style === 'thin'
  //           ? 'fa-thin'
  //           : style === 'brands'
  //             ? 'fa-brands'
  //             : '';

  const spec = styles.find(([f, s]) => f === family && s === style)?.[2];

  const width =
    typeof spec === 'object' && !Array.isArray(spec) ? spec.width : width$;
  const height =
    typeof spec === 'object' && !Array.isArray(spec) ? spec.height : height$;
  const path =
    typeof spec === 'object' && !Array.isArray(spec) ? spec.path : spec;

  if (!path) {
    console.error(
      `Missing path for ${iconName} in family ${family} and style ${style}`
    );
  }

  return {
    prefix,
    iconName,
    icon: [
      width,
      height,
      [], // ligatures
      unicode,
      path!,
    ],
  };
}
